import { SnackbarKey, SnackbarMessage, useSnackbar } from 'notistack';
import React, { RefObject, useImperativeHandle, useRef } from 'react';

import { CloseIcon } from '@icons';
import { IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import themeClasses from './styles';
import { useClickOutside } from './useOutsideClick';

const useStyles = makeStyles(themeClasses);

type ButtonProps = { id: SnackbarKey; message: SnackbarMessage };
interface ParsedMessage {
  postId: string;
  authorId: string;
  commentId: number;
  html: string;
}

const getObjectFromString = (str: string): ParsedMessage => JSON.parse(str);

const NewComment = React.forwardRef<HTMLDivElement, ButtonProps>(({ id, message }, ref) => {
  const { closeSnackbar } = useSnackbar();
  const themeStyles = useStyles();
  const msg = getObjectFromString(message as string);
  const { postId, html } = msg;

  const { linkWrapper } = themeStyles;

  const innerRef = useRef<HTMLDivElement>(null);
  // Привязываем к  внешней ссылке current внутренней, для проверки клика вне компонента
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  useImperativeHandle(ref, () => innerRef.current!, [innerRef]);

  const handleClose = () => {
    closeSnackbar(id);
  };

  useClickOutside(innerRef as RefObject<HTMLElement>, handleClose);

  return (
    <div ref={innerRef}>
      <Link
        className={linkWrapper}
        to={{ pathname: `/userPost/${postId}`, state: { scrollToComments: true } }}
        onClick={handleClose}
      >
        {<div dangerouslySetInnerHTML={{ __html: html }} />}
        <IconButton
          color="inherit"
          aria-label="close drawer"
          onClick={(evt) => {
            evt.preventDefault();
            handleClose();
          }}
        >
          <CloseIcon />
        </IconButton>
      </Link>
    </div>
  );
});

export default NewComment;
